export default {
  bind: (el, binding) => {
    const SCROLL_DOM = el
    SCROLL_DOM.addEventListener('scroll', function () {
      const condition = SCROLL_DOM.scrollHeight - SCROLL_DOM.scrollTop <= SCROLL_DOM.clientHeight
      if (condition) {
        binding.value()
      }
    })
  }
}
